if (!customElements.get('product-sticky-bar')) {
    customElements.define(
        'product-sticky-bar',
        class ProductStickyBar extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    stickyBarHandler: `#ProductSubmitButton-${ this.sectionId }`,
                    header: '.section-header'
                };
                
                this.classes = {
                    isActive: 'is-active',
                    isHidden: 'is-hidden'
                }

                this.requestAnimationFrameId = null;
                this.requestVisibilityCheck = this.requestVisibilityCheck.bind(this);
                this.checkStickyBarVisibility = this.checkStickyBarVisibility.bind(this);
            }

            get sectionId() {
                return this.dataset.section;
            }

            connectedCallback() {
                this.initStickyBar();
            }

            disconnectedCallback() {
                window.removeEventListener('scroll', this.requestVisibilityCheck);
                window.removeEventListener('resize', this.requestVisibilityCheck);
                this.requestAnimationFrameId && cancelAnimationFrame(this.requestAnimationFrameId);
            }

            initStickyBar() {
                this.stickyBarHandler = document.querySelector(this.selectors.stickyBarHandler);

                if(!this.stickyBarHandler) {
                    return
                }

                this.header = document.querySelector(this.selectors.header);
                
                window.addEventListener('scroll', this.requestVisibilityCheck);
                window.addEventListener('resize', this.requestVisibilityCheck);
                this.checkStickyBarVisibility();
            }

            getHeaderBottomPosition() {
                if (!this.header) return 0;
                const rect = this.header.getBoundingClientRect();
                return rect.bottom;
            }

            requestVisibilityCheck() {
                if (this.requestAnimationFrameId) return;
                this.requestAnimationFrameId = requestAnimationFrame(() => {
                    this.checkStickyBarVisibility();
                    this.requestAnimationFrameId = null;
                });
            }

            checkStickyBarVisibility() {
                if (!this.stickyBarHandler) return;
                
                const headerBottom = this.getHeaderBottomPosition();
                const rect = this.stickyBarHandler.getBoundingClientRect();
                const intersectsHeader = rect.top < headerBottom && rect.bottom > 0;
                const intersectsViewport = rect.top < window.innerHeight && rect.top > 0;
                const crossedBottomViewport = rect.top > window.innerHeight;
                const showStickyBar = (intersectsHeader || !intersectsViewport) && !crossedBottomViewport;
                
                this.classList.toggle(this.classes.isActive, showStickyBar);
            }
        }
    );
  }